import React from 'react';
import { ThemeProvider } from './components/ThemeContext';
import { LanguageProvider } from './components/LanguageContext';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { WhyDifferent } from './components/WhyDifferent';
import { HowItWorks } from './components/HowItWorks';
import { Security } from './components/Security';
import { Pricing } from './components/Pricing';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
export function App() {
  return <ThemeProvider data-id="element-0">
      <LanguageProvider data-id="element-1">
        <div className="min-h-screen bg-svt-bg text-svt-text font-sans selection:bg-svt-pink selection:text-white transition-colors duration-300" data-id="element-2">
          <Header data-id="element-3" />
          <main data-id="element-4">
            <Hero data-id="element-5" />
            <About data-id="element-6" />
            <WhyDifferent data-id="element-7" />
            <HowItWorks data-id="element-8" />
            <Security data-id="element-9" />
            <Pricing data-id="element-10" />
            <CTA data-id="element-11" />
          </main>
          <Footer data-id="element-12" />
        </div>
      </LanguageProvider>
    </ThemeProvider>;
}